import { useEffect, useState } from 'react';
import TranscriptUploader from '../../components/reusable/TranscriptUploader';

export default function TranscriptUpload() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const loggedInUser = localStorage.getItem('diploAccessUser');
    setUser(loggedInUser);
  });

  return <div>{user && <TranscriptUploader />}</div>;
}